import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { DriversList } from "@lib/types/driver";

export const getDrivers = async (): Promise<DriversList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_DRIVER);
  return data;
};

export const getUnusedSlots = async (): Promise<string[]> => {
  const { data } = await axiosClient.get(
    `${ENDPOINTS.BASE_DRIVER}/unused-slots`
  );

  return data.map(String);
};
